import actionTypes from 'SRC/modules/redux/actionTypes'

export const setInfo = info => ({
  type: actionTypes.SET_USER_DETAIL_INFO,
  payload: info
})
